import md5 from 'js-md5';

const addAPIresponseToCache = (state, payload) => {
  const hash = state.requestParams.currentParamsHash;
  const { module } = payload;

  if (!(hash in state.responseCache[module])) {
    state.responseCache[module][hash] = payload.response;
  }
};
const persistedStateKey = (state, payload) => {
  state.persistedStateKey = payload;
};
const updateBuildClientList = (state, payload) => {
  state.buildClientList = payload;
};
const updateBuildIndustryClientList = (state, payload) => {
  state.buildIndustryClientList = payload;
};
const updateCompanySelectModalState = (state, payload) => {
  state.modalStates.companySelectModalState = payload;
};
const updateComparisonMode = (state, payload) => {
  if (payload === 'date') {
    state.comparisonMode = 'date';
  } else if (payload === 'industry') {
    state.comparisonMode = 'industry';
  }
};
const updateComparisonYears = (state, payload) => {
  state.comparisonYears = payload;
};
const updateClientList = (state, payload) => {
  state.clientList = payload;
};
const updateClientOrRareMode = (state, payload) => {
  state.clientOrRareMode = payload;
};
const updateCurrentClient = (state, payload) => {
  state.requestParams.currentClient = payload;
};
const updateCurrentClientDisplayName = (state, payload) => {
  state.displayData.currentClient = payload;
};
const updateCurrentColors = (state, payload) => {
  state.currentColors = payload;
};
const updateCurrentPage = (state, payload) => {
  state.currentPage = payload;
};
const updateCurrentParamsHash = (state, payload = 'currentParamsHash') => {
  state.requestParams[payload] = md5(
    `${state.comparisonYears}
     ${state.requestParams.industryAverage}
     ${state.comparisonMode}
     ${state.requestParams.currentClient}
     ${state.requestParams.toDate}
     ${state.requestParams.fromDate}`,
  );
};
const updateDataFormat = (state, payload) => {
  state.requestParams.dataFormat = payload;
};
const updateDatePickerModalState = (state, payload) => {
  state.modalStates.datePickerModalState = payload;
};
const updateDefaultFromDate = (state, payload) => {
  state.defaultFromDate = payload;
};
const updateDefaultToDate = (state, payload) => {
  state.defaultToDate = payload;
};
const updateFromDate = (state, payload) => {
  state.requestParams.fromDate = payload;
};
const updateIndustryAverage = (state, payload) => {
  state.requestParams.industryAverage = payload;
};
const updateIndustryLoadingState = (state, payload) => {
  state.modalStates.industryLoadingState = payload;
};
const updateIndustrySelectStateDisabled = (state, payload) => {
  state.industrySelectStateDisabled = payload;
};
const updateInitialLoad = (state, payload) => {
  state.initialLoad[payload.page] = payload.value;
};
const updateLegendData = (state, payload) => {
  state.legendData = payload;
};
const updateLoadingModalState = (state, payload) => {
  state.modalStates.loadingModal = payload;
};
const updatePageTitle = (state, payload) => {
  state.displayData.pageTitle = payload;
};
const updateShowBurgerMenu = (state, payload) => {
  state.displayData.showBurgerMenu = payload;
};
const updateShowControlPanel = (state, payload) => {
  state.displayData.showControlPanel = payload;
};
const updateShowDownloadIcon = (state, payload) => {
  state.displayData.showDownloadIcon = payload;
};
const updateShowLogoutIcon = (state, payload) => {
  state.displayData.showLogoutIcon = payload;
};
const updateShowNavigationLinks = (state, payload) => {
  state.displayData.showNavigationLinks = payload;
};
const updateSummaryLoadingState = (state, payload) => {
  state.modalStates.summaryLoadingState = payload;
};
const updateToDate = (state, payload) => {
  state.requestParams.toDate = payload;
};
const updateTotalApplications = (state, payload) => {
  state.displayData.totalApplications = payload;
};

export default {
  addAPIresponseToCache,
  persistedStateKey,
  updateBuildClientList,
  updateBuildIndustryClientList,
  updateCompanySelectModalState,
  updateComparisonMode,
  updateComparisonYears,
  updateClientList,
  updateClientOrRareMode,
  updateCurrentClient,
  updateCurrentClientDisplayName,
  updateCurrentColors,
  updateCurrentPage,
  updateCurrentParamsHash,
  updateDataFormat,
  updateDatePickerModalState,
  updateDefaultFromDate,
  updateDefaultToDate,
  updateFromDate,
  updateIndustryAverage,
  updateIndustryLoadingState,
  updateIndustrySelectStateDisabled,
  updateInitialLoad,
  updateLegendData,
  updateLoadingModalState,
  updatePageTitle,
  updateShowBurgerMenu,
  updateShowControlPanel,
  updateShowDownloadIcon,
  updateShowLogoutIcon,
  updateShowNavigationLinks,
  updateSummaryLoadingState,
  updateToDate,
  updateTotalApplications,
};
